import { FaInfinity } from '@react-icons/all-files/fa/FaInfinity';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import { FaMagic } from '@react-icons/all-files/fa/FaMagic';

export const PLANS = [
    {
      id: 'trial',
      label: '7-day trial',
      bestValue: true,
      price: 1.95,
      productId: 'prod_STXM6wHZRTbeJM',
      description: [
        { icon: <FaInfinity />, text: 'Unlimited resume downloads' },
        { icon: <FaStar />, text: 'AI-tailored resumes for each job' },
        { icon: <FaMagic />, text: 'Custom AI-generated cover letters' },
      ],
      renewal: 'After 7 days, it renews to $27.88 billed monthly, and you can cancel at any time.',
    },
    {
      id: '3mo',
      label: '3 months',
      price: 27.88,
      productId: 'prod_STXN5A1OUla1Oi',
      oneTime: true,
    },
    {
      id: '6mo',
      label: '6 months',
      price: 47.88,
      productId: 'prod_STXN8x06Y39suI',
      oneTime: true,
    },
  ];